import React from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import { useSelectTreatment } from '@hooks/useSelectTreatment'
import { UpsellTreatmentScreen } from '@screens/UpsellTreatmentScreen/UpsellTreatmentScreen'
import useTreatmentUpsellDetails from '@hooks/useTreatmentUpsellDetails'
import { clearVitaminDUpsellInformation, setVitaminDUpsellInformation, useUpsellDispatch } from '@context/UpsellContext'

export const UpsellTreatment = () => {
  const history = useHistory()
  const upsellDispatch = useUpsellDispatch()
  const selectTreatment = useSelectTreatment()
  const { data: upsellDetails } = useTreatmentUpsellDetails()
  const { treatmentBundleToBeUpsoldTo, treatmentBundleToBeUpsoldFromReferenceId } = upsellDetails || {}

  const onBackClick = () => {
    history.push('/')
  }

  if (!upsellDetails) {
    return <Redirect to={routes.treatment} />
  }
  const isVitaminDUpsell = upsellDetails.upsellHeadlineTranslationKey.includes('vitamin_d')

  const continueWithUpsell = () => {
    selectTreatment(treatmentBundleToBeUpsoldTo?.referenceId || '')
    if (isVitaminDUpsell) upsellDispatch(setVitaminDUpsellInformation())
  }

  const continueWithoutUpsell = () => {
    selectTreatment(treatmentBundleToBeUpsoldFromReferenceId || '')
    upsellDispatch(clearVitaminDUpsellInformation())
  }

  return (
    <UpsellTreatmentScreen
      upsellDetails={upsellDetails}
      onBackClick={onBackClick}
      continueWithUpsell={continueWithUpsell}
      continueWithoutUpsell={continueWithoutUpsell}
    />
  )
}
